export const AUTH_ROUTES = {
    SIGN_IN: '/onboarding?entry=signin',
    SIGN_UP: '/onboarding?entry=signup',
    SIGNUP_EMAIL_VERIFICATION: '/onboarding?entry=email-verification',
    EXISTING_WEBSITE: '/onboarding?entry=existing-website',
} as const